























import {Component, Vue} from 'vue-property-decorator'
import * as Helper from '@/helpers'

export interface DisplayOptions {
  src: string
  alt?: string
  showDownload?: boolean
}

@Component
export default class ModalImageDisplay extends Vue {
  options: DisplayOptions | null = null

  async openEvent(options: DisplayOptions) {
    this.$emit('open')
    this.options = options
  }

  closeEvent() {
    this.options = null
    this.$emit('close')
  }

  download() {
    if (this.options) {
      Helper.openUrl(this.options.src)
    }
  }

  close() {
    this.$modal.close('imageDisplay')
  }
}
